<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="$t('LeftPanel_subtitle_exploitation')"/>
    <DxExploitation />
    <div class="footer-map">
      <f7-button
        v-if="currentPoint.pointName !== ''"
        class="button-next-screen"
        raised
        type="default"
        text-color="grey"
        styling-mode="outlined"
        @click="goToFloor"
      >
        {{ $t("Continue") }}
      </f7-button>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DxExploitation from "../components/DxExploitation.vue";
import navbar from "../components/NavBar.vue";

export default {
  components: {
    DxExploitation,
    navbar,
  },
  computed: {
    ...mapState("Mopeco", ["currentPoint"]),
  },
  methods: {
    beforein() {
      window.addEventListener("message", (e) => {
        if (e.data.event === "updatedCurrentPoint") {
          this.uploadCurrentPoint();
        }
      });
    },
    uploadCurrentPoint() {
      this.clearAll();
      this.updateCurrentPoint(JSON.parse(localStorage.getItem("currentPoint")));
    },
    goToFloor() {
      this.setShowFloor(true);
      this.$f7.views.main.router.navigate("/floor/");
    },
    ...mapActions("Mopeco", ["updateCurrentPoint", "clearAll", "setShowFloor"]),
  },
};
</script>

<style>
.footer-map {
  margin-top: 5px;
  width: 100%;
  height: auto;
}
</style>
